/** Support tickets — user + agent panel copy (non-English). */
export const panelSupportTicketsByLang = {
  es: {
    'user.layout.nav.support': "Soporte",
    'user.page.support': "Soporte",
    'user.support.myTickets': "Mis tickets",
    'user.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'user.support.newTicket': "Nuevo ticket",
    'user.support.empty': "Aún no tienes tickets de soporte.",
    'user.support.loading': "Cargando…",
    'user.support.backToList': "Volver a tickets",
    'user.support.category': "Categoría",
    'user.support.subject': "Asunto",
    'user.support.subjectPlaceholder': "Breve resumen del problema",
    'user.support.message': "Mensaje",
    'user.support.messagePlaceholder': "Describe tu problema…",
    'user.support.attachments': "Imágenes",
    'user.support.addImages': "Añadir imágenes",
    'user.support.removeImage': "Quitar imagen",
    'user.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'user.support.submit': "Enviar ticket",
    'user.support.submitting': "Enviando…",
    'user.support.reply': "Tu respuesta",
    'user.support.replyPlaceholder': "Escribe una respuesta…",
    'user.support.sendReply': "Enviar respuesta",
    'user.support.closeTicket': "Cerrar ticket",
    'user.support.closing': "Cerrando…",
    'user.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'user.support.roleAdmin': "Soporte",
    'user.support.roleYou': "Tú",
    'user.support.status.PENDING': "Pendiente",
    'user.support.status.PROCESSING': "En proceso",
    'user.support.status.CLOSED': "Cerrado",
    'user.support.category.Account': "Cuenta",
    'user.support.category.Deposit': "Depósito",
    'user.support.category.Withdrawal': "Retiro",
    'user.support.category.Investment': "Inversión",
    'user.support.category.Technical': "Técnico",
    'user.support.category.Other': "Otro",
    'user.support.toastLoadFail': "No se pudieron cargar los tickets",
    'user.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'user.support.toastCreateOk': "Ticket creado",
    'user.support.toastCreateFail': "No se pudo crear el ticket",
    'user.support.toastReplyOk': "Respuesta enviada",
    'user.support.toastReplyFail': "No se pudo enviar la respuesta",
    'user.support.toastCloseOk': "Ticket cerrado",
    'user.support.toastCloseFail': "No se pudo cerrar el ticket",
    'agent.layout.nav.support': "Soporte",
    'agent.page.support': "Soporte",
    'agent.support.myTickets': "Mis tickets",
    'agent.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'agent.support.newTicket': "Nuevo ticket",
    'agent.support.empty': "Aún no tienes tickets de soporte.",
    'agent.support.loading': "Cargando…",
    'agent.support.backToList': "Volver a tickets",
    'agent.support.category': "Categoría",
    'agent.support.subject': "Asunto",
    'agent.support.subjectPlaceholder': "Breve resumen del problema",
    'agent.support.message': "Mensaje",
    'agent.support.messagePlaceholder': "Describe tu problema…",
    'agent.support.attachments': "Imágenes",
    'agent.support.addImages': "Añadir imágenes",
    'agent.support.removeImage': "Quitar imagen",
    'agent.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'agent.support.submit': "Enviar ticket",
    'agent.support.submitting': "Enviando…",
    'agent.support.reply': "Tu respuesta",
    'agent.support.replyPlaceholder': "Escribe una respuesta…",
    'agent.support.sendReply': "Enviar respuesta",
    'agent.support.closeTicket': "Cerrar ticket",
    'agent.support.closing': "Cerrando…",
    'agent.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'agent.support.roleAdmin': "Soporte",
    'agent.support.roleYou': "Tú",
    'agent.support.status.PENDING': "Pendiente",
    'agent.support.status.PROCESSING': "En proceso",
    'agent.support.status.CLOSED': "Cerrado",
    'agent.support.category.Account': "Cuenta",
    'agent.support.category.Deposit': "Depósito",
    'agent.support.category.Withdrawal': "Retiro",
    'agent.support.category.Investment': "Inversión",
    'agent.support.category.Technical': "Técnico",
    'agent.support.category.Other': "Otro",
    'agent.support.toastLoadFail': "No se pudieron cargar los tickets",
    'agent.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'agent.support.toastCreateOk': "Ticket creado",
    'agent.support.toastCreateFail': "No se pudo crear el ticket",
    'agent.support.toastReplyOk': "Respuesta enviada",
    'agent.support.toastReplyFail': "No se pudo enviar la respuesta",
    'agent.support.toastCloseOk': "Ticket cerrado",
    'agent.support.toastCloseFail': "No se pudo cerrar el ticket",
  },
  de: {
    'user.layout.nav.support': "Support",
    'user.page.support': "Support",
    'user.support.myTickets': "Meine Tickets",
    'user.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'user.support.newTicket': "Neues Ticket",
    'user.support.empty': "Aún no tienes tickets de soporte.",
    'user.support.loading': "Cargando…",
    'user.support.backToList': "Volver a tickets",
    'user.support.category': "Categoría",
    'user.support.subject': "Asunto",
    'user.support.subjectPlaceholder': "Breve resumen del problema",
    'user.support.message': "Mensaje",
    'user.support.messagePlaceholder': "Describe tu problema…",
    'user.support.attachments': "Imágenes",
    'user.support.addImages': "Añadir imágenes",
    'user.support.removeImage': "Bild entfernen",
    'user.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'user.support.submit': "Enviar ticket",
    'user.support.submitting': "Enviando…",
    'user.support.reply': "Tu respuesta",
    'user.support.replyPlaceholder': "Escribe una respuesta…",
    'user.support.sendReply': "Enviar respuesta",
    'user.support.closeTicket': "Cerrar ticket",
    'user.support.closing': "Cerrando…",
    'user.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'user.support.roleAdmin': "Support",
    'user.support.roleYou': "Tú",
    'user.support.status.PENDING': "Ausstehend",
    'user.support.status.PROCESSING': "In Bearbeitung",
    'user.support.status.CLOSED': "Geschlossen",
    'user.support.category.Account': "Cuenta",
    'user.support.category.Deposit': "Depósito",
    'user.support.category.Withdrawal': "Retiro",
    'user.support.category.Investment': "Inversión",
    'user.support.category.Technical': "Técnico",
    'user.support.category.Other': "Otro",
    'user.support.toastLoadFail': "No se pudieron cargar los tickets",
    'user.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'user.support.toastCreateOk': "Ticket creado",
    'user.support.toastCreateFail': "No se pudo crear el ticket",
    'user.support.toastReplyOk': "Respuesta enviada",
    'user.support.toastReplyFail': "No se pudo enviar la respuesta",
    'user.support.toastCloseOk': "Ticket cerrado",
    'user.support.toastCloseFail': "No se pudo cerrar el ticket",
    'agent.layout.nav.support': "Support",
    'agent.page.support': "Support",
    'agent.support.myTickets': "Meine Tickets",
    'agent.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'agent.support.newTicket': "Neues Ticket",
    'agent.support.empty': "Aún no tienes tickets de soporte.",
    'agent.support.loading': "Cargando…",
    'agent.support.backToList': "Volver a tickets",
    'agent.support.category': "Categoría",
    'agent.support.subject': "Asunto",
    'agent.support.subjectPlaceholder': "Breve resumen del problema",
    'agent.support.message': "Mensaje",
    'agent.support.messagePlaceholder': "Describe tu problema…",
    'agent.support.attachments': "Imágenes",
    'agent.support.addImages': "Añadir imágenes",
    'agent.support.removeImage': "Bild entfernen",
    'agent.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'agent.support.submit': "Enviar ticket",
    'agent.support.submitting': "Enviando…",
    'agent.support.reply': "Tu respuesta",
    'agent.support.replyPlaceholder': "Escribe una respuesta…",
    'agent.support.sendReply': "Enviar respuesta",
    'agent.support.closeTicket': "Cerrar ticket",
    'agent.support.closing': "Cerrando…",
    'agent.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'agent.support.roleAdmin': "Support",
    'agent.support.roleYou': "Tú",
    'agent.support.status.PENDING': "Ausstehend",
    'agent.support.status.PROCESSING': "In Bearbeitung",
    'agent.support.status.CLOSED': "Geschlossen",
    'agent.support.category.Account': "Cuenta",
    'agent.support.category.Deposit': "Depósito",
    'agent.support.category.Withdrawal': "Retiro",
    'agent.support.category.Investment': "Inversión",
    'agent.support.category.Technical': "Técnico",
    'agent.support.category.Other': "Otro",
    'agent.support.toastLoadFail': "No se pudieron cargar los tickets",
    'agent.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'agent.support.toastCreateOk': "Ticket creado",
    'agent.support.toastCreateFail': "No se pudo crear el ticket",
    'agent.support.toastReplyOk': "Respuesta enviada",
    'agent.support.toastReplyFail': "No se pudo enviar la respuesta",
    'agent.support.toastCloseOk': "Ticket cerrado",
    'agent.support.toastCloseFail': "No se pudo cerrar el ticket",
  },
  fr: {
    'user.layout.nav.support': "Assistance",
    'user.page.support': "Assistance",
    'user.support.myTickets': "Mes tickets",
    'user.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'user.support.newTicket': "Nouveau ticket",
    'user.support.empty': "Aún no tienes tickets de soporte.",
    'user.support.loading': "Cargando…",
    'user.support.backToList': "Volver a tickets",
    'user.support.category': "Categoría",
    'user.support.subject': "Asunto",
    'user.support.subjectPlaceholder': "Breve resumen del problema",
    'user.support.message': "Mensaje",
    'user.support.messagePlaceholder': "Describe tu problema…",
    'user.support.attachments': "Imágenes",
    'user.support.addImages': "Añadir imágenes",
    'user.support.removeImage': "Supprimer l'image",
    'user.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'user.support.submit': "Enviar ticket",
    'user.support.submitting': "Enviando…",
    'user.support.reply': "Tu respuesta",
    'user.support.replyPlaceholder': "Escribe una respuesta…",
    'user.support.sendReply': "Enviar respuesta",
    'user.support.closeTicket': "Cerrar ticket",
    'user.support.closing': "Cerrando…",
    'user.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'user.support.roleAdmin': "Assistance",
    'user.support.roleYou': "Tú",
    'user.support.status.PENDING': "En attente",
    'user.support.status.PROCESSING': "En cours",
    'user.support.status.CLOSED': "Fermé",
    'user.support.category.Account': "Cuenta",
    'user.support.category.Deposit': "Depósito",
    'user.support.category.Withdrawal': "Retiro",
    'user.support.category.Investment': "Inversión",
    'user.support.category.Technical': "Técnico",
    'user.support.category.Other': "Otro",
    'user.support.toastLoadFail': "No se pudieron cargar los tickets",
    'user.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'user.support.toastCreateOk': "Ticket creado",
    'user.support.toastCreateFail': "No se pudo crear el ticket",
    'user.support.toastReplyOk': "Respuesta enviada",
    'user.support.toastReplyFail': "No se pudo enviar la respuesta",
    'user.support.toastCloseOk': "Ticket cerrado",
    'user.support.toastCloseFail': "No se pudo cerrar el ticket",
    'agent.layout.nav.support': "Assistance",
    'agent.page.support': "Assistance",
    'agent.support.myTickets': "Mes tickets",
    'agent.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'agent.support.newTicket': "Nouveau ticket",
    'agent.support.empty': "Aún no tienes tickets de soporte.",
    'agent.support.loading': "Cargando…",
    'agent.support.backToList': "Volver a tickets",
    'agent.support.category': "Categoría",
    'agent.support.subject': "Asunto",
    'agent.support.subjectPlaceholder': "Breve resumen del problema",
    'agent.support.message': "Mensaje",
    'agent.support.messagePlaceholder': "Describe tu problema…",
    'agent.support.attachments': "Imágenes",
    'agent.support.addImages': "Añadir imágenes",
    'agent.support.removeImage': "Supprimer l'image",
    'agent.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'agent.support.submit': "Enviar ticket",
    'agent.support.submitting': "Enviando…",
    'agent.support.reply': "Tu respuesta",
    'agent.support.replyPlaceholder': "Escribe una respuesta…",
    'agent.support.sendReply': "Enviar respuesta",
    'agent.support.closeTicket': "Cerrar ticket",
    'agent.support.closing': "Cerrando…",
    'agent.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'agent.support.roleAdmin': "Assistance",
    'agent.support.roleYou': "Tú",
    'agent.support.status.PENDING': "En attente",
    'agent.support.status.PROCESSING': "En cours",
    'agent.support.status.CLOSED': "Fermé",
    'agent.support.category.Account': "Cuenta",
    'agent.support.category.Deposit': "Depósito",
    'agent.support.category.Withdrawal': "Retiro",
    'agent.support.category.Investment': "Inversión",
    'agent.support.category.Technical': "Técnico",
    'agent.support.category.Other': "Otro",
    'agent.support.toastLoadFail': "No se pudieron cargar los tickets",
    'agent.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'agent.support.toastCreateOk': "Ticket creado",
    'agent.support.toastCreateFail': "No se pudo crear el ticket",
    'agent.support.toastReplyOk': "Respuesta enviada",
    'agent.support.toastReplyFail': "No se pudo enviar la respuesta",
    'agent.support.toastCloseOk': "Ticket cerrado",
    'agent.support.toastCloseFail': "No se pudo cerrar el ticket",
  },
  ar: {
    'user.layout.nav.support': "الدعم",
    'user.page.support': "الدعم",
    'user.support.myTickets': "تذاكري",
    'user.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'user.support.newTicket': "تذكرة جديدة",
    'user.support.empty': "Aún no tienes tickets de soporte.",
    'user.support.loading': "Cargando…",
    'user.support.backToList': "Volver a tickets",
    'user.support.category': "Categoría",
    'user.support.subject': "Asunto",
    'user.support.subjectPlaceholder': "Breve resumen del problema",
    'user.support.message': "Mensaje",
    'user.support.messagePlaceholder': "Describe tu problema…",
    'user.support.attachments': "Imágenes",
    'user.support.addImages': "Añadir imágenes",
    'user.support.removeImage': "إزالة الصورة",
    'user.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'user.support.submit': "Enviar ticket",
    'user.support.submitting': "Enviando…",
    'user.support.reply': "Tu respuesta",
    'user.support.replyPlaceholder': "Escribe una respuesta…",
    'user.support.sendReply': "Enviar respuesta",
    'user.support.closeTicket': "Cerrar ticket",
    'user.support.closing': "Cerrando…",
    'user.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'user.support.roleAdmin': "الدعم",
    'user.support.roleYou': "Tú",
    'user.support.status.PENDING': "معلق",
    'user.support.status.PROCESSING': "قيد المعالجة",
    'user.support.status.CLOSED': "مغلق",
    'user.support.category.Account': "Cuenta",
    'user.support.category.Deposit': "Depósito",
    'user.support.category.Withdrawal': "Retiro",
    'user.support.category.Investment': "Inversión",
    'user.support.category.Technical': "Técnico",
    'user.support.category.Other': "Otro",
    'user.support.toastLoadFail': "No se pudieron cargar los tickets",
    'user.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'user.support.toastCreateOk': "Ticket creado",
    'user.support.toastCreateFail': "No se pudo crear el ticket",
    'user.support.toastReplyOk': "Respuesta enviada",
    'user.support.toastReplyFail': "No se pudo enviar la respuesta",
    'user.support.toastCloseOk': "Ticket cerrado",
    'user.support.toastCloseFail': "No se pudo cerrar el ticket",
    'agent.layout.nav.support': "الدعم",
    'agent.page.support': "الدعم",
    'agent.support.myTickets': "تذاكري",
    'agent.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'agent.support.newTicket': "تذكرة جديدة",
    'agent.support.empty': "Aún no tienes tickets de soporte.",
    'agent.support.loading': "Cargando…",
    'agent.support.backToList': "Volver a tickets",
    'agent.support.category': "Categoría",
    'agent.support.subject': "Asunto",
    'agent.support.subjectPlaceholder': "Breve resumen del problema",
    'agent.support.message': "Mensaje",
    'agent.support.messagePlaceholder': "Describe tu problema…",
    'agent.support.attachments': "Imágenes",
    'agent.support.addImages': "Añadir imágenes",
    'agent.support.removeImage': "إزالة الصورة",
    'agent.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'agent.support.submit': "Enviar ticket",
    'agent.support.submitting': "Enviando…",
    'agent.support.reply': "Tu respuesta",
    'agent.support.replyPlaceholder': "Escribe una respuesta…",
    'agent.support.sendReply': "Enviar respuesta",
    'agent.support.closeTicket': "Cerrar ticket",
    'agent.support.closing': "Cerrando…",
    'agent.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'agent.support.roleAdmin': "الدعم",
    'agent.support.roleYou': "Tú",
    'agent.support.status.PENDING': "معلق",
    'agent.support.status.PROCESSING': "قيد المعالجة",
    'agent.support.status.CLOSED': "مغلق",
    'agent.support.category.Account': "Cuenta",
    'agent.support.category.Deposit': "Depósito",
    'agent.support.category.Withdrawal': "Retiro",
    'agent.support.category.Investment': "Inversión",
    'agent.support.category.Technical': "Técnico",
    'agent.support.category.Other': "Otro",
    'agent.support.toastLoadFail': "No se pudieron cargar los tickets",
    'agent.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'agent.support.toastCreateOk': "Ticket creado",
    'agent.support.toastCreateFail': "No se pudo crear el ticket",
    'agent.support.toastReplyOk': "Respuesta enviada",
    'agent.support.toastReplyFail': "No se pudo enviar la respuesta",
    'agent.support.toastCloseOk': "Ticket cerrado",
    'agent.support.toastCloseFail': "No se pudo cerrar el ticket",
  },
  ja: {
    'user.layout.nav.support': "サポート",
    'user.page.support': "サポート",
    'user.support.myTickets': "マイチケット",
    'user.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'user.support.newTicket': "新規チケット",
    'user.support.empty': "Aún no tienes tickets de soporte.",
    'user.support.loading': "Cargando…",
    'user.support.backToList': "Volver a tickets",
    'user.support.category': "Categoría",
    'user.support.subject': "Asunto",
    'user.support.subjectPlaceholder': "Breve resumen del problema",
    'user.support.message': "Mensaje",
    'user.support.messagePlaceholder': "Describe tu problema…",
    'user.support.attachments': "Imágenes",
    'user.support.addImages': "Añadir imágenes",
    'user.support.removeImage': "画像を削除",
    'user.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'user.support.submit': "Enviar ticket",
    'user.support.submitting': "Enviando…",
    'user.support.reply': "Tu respuesta",
    'user.support.replyPlaceholder': "Escribe una respuesta…",
    'user.support.sendReply': "Enviar respuesta",
    'user.support.closeTicket': "Cerrar ticket",
    'user.support.closing': "Cerrando…",
    'user.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'user.support.roleAdmin': "サポート",
    'user.support.roleYou': "Tú",
    'user.support.status.PENDING': "保留",
    'user.support.status.PROCESSING': "対応中",
    'user.support.status.CLOSED': "完了",
    'user.support.category.Account': "Cuenta",
    'user.support.category.Deposit': "Depósito",
    'user.support.category.Withdrawal': "Retiro",
    'user.support.category.Investment': "Inversión",
    'user.support.category.Technical': "Técnico",
    'user.support.category.Other': "Otro",
    'user.support.toastLoadFail': "No se pudieron cargar los tickets",
    'user.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'user.support.toastCreateOk': "Ticket creado",
    'user.support.toastCreateFail': "No se pudo crear el ticket",
    'user.support.toastReplyOk': "Respuesta enviada",
    'user.support.toastReplyFail': "No se pudo enviar la respuesta",
    'user.support.toastCloseOk': "Ticket cerrado",
    'user.support.toastCloseFail': "No se pudo cerrar el ticket",
    'agent.layout.nav.support': "サポート",
    'agent.page.support': "サポート",
    'agent.support.myTickets': "マイチケット",
    'agent.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'agent.support.newTicket': "新規チケット",
    'agent.support.empty': "Aún no tienes tickets de soporte.",
    'agent.support.loading': "Cargando…",
    'agent.support.backToList': "Volver a tickets",
    'agent.support.category': "Categoría",
    'agent.support.subject': "Asunto",
    'agent.support.subjectPlaceholder': "Breve resumen del problema",
    'agent.support.message': "Mensaje",
    'agent.support.messagePlaceholder': "Describe tu problema…",
    'agent.support.attachments': "Imágenes",
    'agent.support.addImages': "Añadir imágenes",
    'agent.support.removeImage': "画像を削除",
    'agent.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'agent.support.submit': "Enviar ticket",
    'agent.support.submitting': "Enviando…",
    'agent.support.reply': "Tu respuesta",
    'agent.support.replyPlaceholder': "Escribe una respuesta…",
    'agent.support.sendReply': "Enviar respuesta",
    'agent.support.closeTicket': "Cerrar ticket",
    'agent.support.closing': "Cerrando…",
    'agent.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'agent.support.roleAdmin': "サポート",
    'agent.support.roleYou': "Tú",
    'agent.support.status.PENDING': "保留",
    'agent.support.status.PROCESSING': "対応中",
    'agent.support.status.CLOSED': "完了",
    'agent.support.category.Account': "Cuenta",
    'agent.support.category.Deposit': "Depósito",
    'agent.support.category.Withdrawal': "Retiro",
    'agent.support.category.Investment': "Inversión",
    'agent.support.category.Technical': "Técnico",
    'agent.support.category.Other': "Otro",
    'agent.support.toastLoadFail': "No se pudieron cargar los tickets",
    'agent.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'agent.support.toastCreateOk': "Ticket creado",
    'agent.support.toastCreateFail': "No se pudo crear el ticket",
    'agent.support.toastReplyOk': "Respuesta enviada",
    'agent.support.toastReplyFail': "No se pudo enviar la respuesta",
    'agent.support.toastCloseOk': "Ticket cerrado",
    'agent.support.toastCloseFail': "No se pudo cerrar el ticket",
  },
  ko: {
    'user.layout.nav.support': "지원",
    'user.page.support': "지원",
    'user.support.myTickets': "내 티켓",
    'user.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'user.support.newTicket': "새 티켓",
    'user.support.empty': "Aún no tienes tickets de soporte.",
    'user.support.loading': "Cargando…",
    'user.support.backToList': "Volver a tickets",
    'user.support.category': "Categoría",
    'user.support.subject': "Asunto",
    'user.support.subjectPlaceholder': "Breve resumen del problema",
    'user.support.message': "Mensaje",
    'user.support.messagePlaceholder': "Describe tu problema…",
    'user.support.attachments': "Imágenes",
    'user.support.addImages': "Añadir imágenes",
    'user.support.removeImage': "이미지 제거",
    'user.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'user.support.submit': "Enviar ticket",
    'user.support.submitting': "Enviando…",
    'user.support.reply': "Tu respuesta",
    'user.support.replyPlaceholder': "Escribe una respuesta…",
    'user.support.sendReply': "Enviar respuesta",
    'user.support.closeTicket': "Cerrar ticket",
    'user.support.closing': "Cerrando…",
    'user.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'user.support.roleAdmin': "지원",
    'user.support.roleYou': "Tú",
    'user.support.status.PENDING': "대기",
    'user.support.status.PROCESSING': "처리 중",
    'user.support.status.CLOSED': "종료",
    'user.support.category.Account': "Cuenta",
    'user.support.category.Deposit': "Depósito",
    'user.support.category.Withdrawal': "Retiro",
    'user.support.category.Investment': "Inversión",
    'user.support.category.Technical': "Técnico",
    'user.support.category.Other': "Otro",
    'user.support.toastLoadFail': "No se pudieron cargar los tickets",
    'user.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'user.support.toastCreateOk': "Ticket creado",
    'user.support.toastCreateFail': "No se pudo crear el ticket",
    'user.support.toastReplyOk': "Respuesta enviada",
    'user.support.toastReplyFail': "No se pudo enviar la respuesta",
    'user.support.toastCloseOk': "Ticket cerrado",
    'user.support.toastCloseFail': "No se pudo cerrar el ticket",
    'agent.layout.nav.support': "지원",
    'agent.page.support': "지원",
    'agent.support.myTickets': "내 티켓",
    'agent.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'agent.support.newTicket': "새 티켓",
    'agent.support.empty': "Aún no tienes tickets de soporte.",
    'agent.support.loading': "Cargando…",
    'agent.support.backToList': "Volver a tickets",
    'agent.support.category': "Categoría",
    'agent.support.subject': "Asunto",
    'agent.support.subjectPlaceholder': "Breve resumen del problema",
    'agent.support.message': "Mensaje",
    'agent.support.messagePlaceholder': "Describe tu problema…",
    'agent.support.attachments': "Imágenes",
    'agent.support.addImages': "Añadir imágenes",
    'agent.support.removeImage': "이미지 제거",
    'agent.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'agent.support.submit': "Enviar ticket",
    'agent.support.submitting': "Enviando…",
    'agent.support.reply': "Tu respuesta",
    'agent.support.replyPlaceholder': "Escribe una respuesta…",
    'agent.support.sendReply': "Enviar respuesta",
    'agent.support.closeTicket': "Cerrar ticket",
    'agent.support.closing': "Cerrando…",
    'agent.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'agent.support.roleAdmin': "지원",
    'agent.support.roleYou': "Tú",
    'agent.support.status.PENDING': "대기",
    'agent.support.status.PROCESSING': "처리 중",
    'agent.support.status.CLOSED': "종료",
    'agent.support.category.Account': "Cuenta",
    'agent.support.category.Deposit': "Depósito",
    'agent.support.category.Withdrawal': "Retiro",
    'agent.support.category.Investment': "Inversión",
    'agent.support.category.Technical': "Técnico",
    'agent.support.category.Other': "Otro",
    'agent.support.toastLoadFail': "No se pudieron cargar los tickets",
    'agent.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'agent.support.toastCreateOk': "Ticket creado",
    'agent.support.toastCreateFail': "No se pudo crear el ticket",
    'agent.support.toastReplyOk': "Respuesta enviada",
    'agent.support.toastReplyFail': "No se pudo enviar la respuesta",
    'agent.support.toastCloseOk': "Ticket cerrado",
    'agent.support.toastCloseFail': "No se pudo cerrar el ticket",
  },
  pt: {
    'user.layout.nav.support': "Suporte",
    'user.page.support': "Suporte",
    'user.support.myTickets': "Meus tickets",
    'user.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'user.support.newTicket': "Novo ticket",
    'user.support.empty': "Aún no tienes tickets de soporte.",
    'user.support.loading': "Cargando…",
    'user.support.backToList': "Volver a tickets",
    'user.support.category': "Categoría",
    'user.support.subject': "Asunto",
    'user.support.subjectPlaceholder': "Breve resumen del problema",
    'user.support.message': "Mensaje",
    'user.support.messagePlaceholder': "Describe tu problema…",
    'user.support.attachments': "Imágenes",
    'user.support.addImages': "Añadir imágenes",
    'user.support.removeImage': "Remover imagem",
    'user.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'user.support.submit': "Enviar ticket",
    'user.support.submitting': "Enviando…",
    'user.support.reply': "Tu respuesta",
    'user.support.replyPlaceholder': "Escribe una respuesta…",
    'user.support.sendReply': "Enviar respuesta",
    'user.support.closeTicket': "Cerrar ticket",
    'user.support.closing': "Cerrando…",
    'user.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'user.support.roleAdmin': "Suporte",
    'user.support.roleYou': "Tú",
    'user.support.status.PENDING': "Pendente",
    'user.support.status.PROCESSING': "Em andamento",
    'user.support.status.CLOSED': "Fechado",
    'user.support.category.Account': "Cuenta",
    'user.support.category.Deposit': "Depósito",
    'user.support.category.Withdrawal': "Retiro",
    'user.support.category.Investment': "Inversión",
    'user.support.category.Technical': "Técnico",
    'user.support.category.Other': "Otro",
    'user.support.toastLoadFail': "No se pudieron cargar los tickets",
    'user.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'user.support.toastCreateOk': "Ticket creado",
    'user.support.toastCreateFail': "No se pudo crear el ticket",
    'user.support.toastReplyOk': "Respuesta enviada",
    'user.support.toastReplyFail': "No se pudo enviar la respuesta",
    'user.support.toastCloseOk': "Ticket cerrado",
    'user.support.toastCloseFail': "No se pudo cerrar el ticket",
    'agent.layout.nav.support': "Suporte",
    'agent.page.support': "Suporte",
    'agent.support.myTickets': "Meus tickets",
    'agent.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'agent.support.newTicket': "Novo ticket",
    'agent.support.empty': "Aún no tienes tickets de soporte.",
    'agent.support.loading': "Cargando…",
    'agent.support.backToList': "Volver a tickets",
    'agent.support.category': "Categoría",
    'agent.support.subject': "Asunto",
    'agent.support.subjectPlaceholder': "Breve resumen del problema",
    'agent.support.message': "Mensaje",
    'agent.support.messagePlaceholder': "Describe tu problema…",
    'agent.support.attachments': "Imágenes",
    'agent.support.addImages': "Añadir imágenes",
    'agent.support.removeImage': "Remover imagem",
    'agent.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'agent.support.submit': "Enviar ticket",
    'agent.support.submitting': "Enviando…",
    'agent.support.reply': "Tu respuesta",
    'agent.support.replyPlaceholder': "Escribe una respuesta…",
    'agent.support.sendReply': "Enviar respuesta",
    'agent.support.closeTicket': "Cerrar ticket",
    'agent.support.closing': "Cerrando…",
    'agent.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'agent.support.roleAdmin': "Suporte",
    'agent.support.roleYou': "Tú",
    'agent.support.status.PENDING': "Pendente",
    'agent.support.status.PROCESSING': "Em andamento",
    'agent.support.status.CLOSED': "Fechado",
    'agent.support.category.Account': "Cuenta",
    'agent.support.category.Deposit': "Depósito",
    'agent.support.category.Withdrawal': "Retiro",
    'agent.support.category.Investment': "Inversión",
    'agent.support.category.Technical': "Técnico",
    'agent.support.category.Other': "Otro",
    'agent.support.toastLoadFail': "No se pudieron cargar los tickets",
    'agent.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'agent.support.toastCreateOk': "Ticket creado",
    'agent.support.toastCreateFail': "No se pudo crear el ticket",
    'agent.support.toastReplyOk': "Respuesta enviada",
    'agent.support.toastReplyFail': "No se pudo enviar la respuesta",
    'agent.support.toastCloseOk': "Ticket cerrado",
    'agent.support.toastCloseFail': "No se pudo cerrar el ticket",
  },
  it: {
    'user.layout.nav.support': "Supporto",
    'user.page.support': "Supporto",
    'user.support.myTickets': "I miei ticket",
    'user.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'user.support.newTicket': "Nuovo ticket",
    'user.support.empty': "Aún no tienes tickets de soporte.",
    'user.support.loading': "Cargando…",
    'user.support.backToList': "Volver a tickets",
    'user.support.category': "Categoría",
    'user.support.subject': "Asunto",
    'user.support.subjectPlaceholder': "Breve resumen del problema",
    'user.support.message': "Mensaje",
    'user.support.messagePlaceholder': "Describe tu problema…",
    'user.support.attachments': "Imágenes",
    'user.support.addImages': "Añadir imágenes",
    'user.support.removeImage': "Rimuovi immagine",
    'user.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'user.support.submit': "Enviar ticket",
    'user.support.submitting': "Enviando…",
    'user.support.reply': "Tu respuesta",
    'user.support.replyPlaceholder': "Escribe una respuesta…",
    'user.support.sendReply': "Enviar respuesta",
    'user.support.closeTicket': "Cerrar ticket",
    'user.support.closing': "Cerrando…",
    'user.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'user.support.roleAdmin': "Supporto",
    'user.support.roleYou': "Tú",
    'user.support.status.PENDING': "In attesa",
    'user.support.status.PROCESSING': "In lavorazione",
    'user.support.status.CLOSED': "Chiuso",
    'user.support.category.Account': "Cuenta",
    'user.support.category.Deposit': "Depósito",
    'user.support.category.Withdrawal': "Retiro",
    'user.support.category.Investment': "Inversión",
    'user.support.category.Technical': "Técnico",
    'user.support.category.Other': "Otro",
    'user.support.toastLoadFail': "No se pudieron cargar los tickets",
    'user.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'user.support.toastCreateOk': "Ticket creado",
    'user.support.toastCreateFail': "No se pudo crear el ticket",
    'user.support.toastReplyOk': "Respuesta enviada",
    'user.support.toastReplyFail': "No se pudo enviar la respuesta",
    'user.support.toastCloseOk': "Ticket cerrado",
    'user.support.toastCloseFail': "No se pudo cerrar el ticket",
    'agent.layout.nav.support': "Supporto",
    'agent.page.support': "Supporto",
    'agent.support.myTickets': "I miei ticket",
    'agent.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'agent.support.newTicket': "Nuovo ticket",
    'agent.support.empty': "Aún no tienes tickets de soporte.",
    'agent.support.loading': "Cargando…",
    'agent.support.backToList': "Volver a tickets",
    'agent.support.category': "Categoría",
    'agent.support.subject': "Asunto",
    'agent.support.subjectPlaceholder': "Breve resumen del problema",
    'agent.support.message': "Mensaje",
    'agent.support.messagePlaceholder': "Describe tu problema…",
    'agent.support.attachments': "Imágenes",
    'agent.support.addImages': "Añadir imágenes",
    'agent.support.removeImage': "Rimuovi immagine",
    'agent.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'agent.support.submit': "Enviar ticket",
    'agent.support.submitting': "Enviando…",
    'agent.support.reply': "Tu respuesta",
    'agent.support.replyPlaceholder': "Escribe una respuesta…",
    'agent.support.sendReply': "Enviar respuesta",
    'agent.support.closeTicket': "Cerrar ticket",
    'agent.support.closing': "Cerrando…",
    'agent.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'agent.support.roleAdmin': "Supporto",
    'agent.support.roleYou': "Tú",
    'agent.support.status.PENDING': "In attesa",
    'agent.support.status.PROCESSING': "In lavorazione",
    'agent.support.status.CLOSED': "Chiuso",
    'agent.support.category.Account': "Cuenta",
    'agent.support.category.Deposit': "Depósito",
    'agent.support.category.Withdrawal': "Retiro",
    'agent.support.category.Investment': "Inversión",
    'agent.support.category.Technical': "Técnico",
    'agent.support.category.Other': "Otro",
    'agent.support.toastLoadFail': "No se pudieron cargar los tickets",
    'agent.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'agent.support.toastCreateOk': "Ticket creado",
    'agent.support.toastCreateFail': "No se pudo crear el ticket",
    'agent.support.toastReplyOk': "Respuesta enviada",
    'agent.support.toastReplyFail': "No se pudo enviar la respuesta",
    'agent.support.toastCloseOk': "Ticket cerrado",
    'agent.support.toastCloseFail': "No se pudo cerrar el ticket",
  },
  ru: {
    'user.layout.nav.support': "Поддержка",
    'user.page.support': "Поддержка",
    'user.support.myTickets': "Мои тикеты",
    'user.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'user.support.newTicket': "Новый тикет",
    'user.support.empty': "Aún no tienes tickets de soporte.",
    'user.support.loading': "Cargando…",
    'user.support.backToList': "Volver a tickets",
    'user.support.category': "Categoría",
    'user.support.subject': "Asunto",
    'user.support.subjectPlaceholder': "Breve resumen del problema",
    'user.support.message': "Mensaje",
    'user.support.messagePlaceholder': "Describe tu problema…",
    'user.support.attachments': "Imágenes",
    'user.support.addImages': "Añadir imágenes",
    'user.support.removeImage': "Удалить изображение",
    'user.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'user.support.submit': "Enviar ticket",
    'user.support.submitting': "Enviando…",
    'user.support.reply': "Tu respuesta",
    'user.support.replyPlaceholder': "Escribe una respuesta…",
    'user.support.sendReply': "Enviar respuesta",
    'user.support.closeTicket': "Cerrar ticket",
    'user.support.closing': "Cerrando…",
    'user.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'user.support.roleAdmin': "Поддержка",
    'user.support.roleYou': "Tú",
    'user.support.status.PENDING': "Ожидает",
    'user.support.status.PROCESSING': "В работе",
    'user.support.status.CLOSED': "Закрыт",
    'user.support.category.Account': "Cuenta",
    'user.support.category.Deposit': "Depósito",
    'user.support.category.Withdrawal': "Retiro",
    'user.support.category.Investment': "Inversión",
    'user.support.category.Technical': "Técnico",
    'user.support.category.Other': "Otro",
    'user.support.toastLoadFail': "No se pudieron cargar los tickets",
    'user.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'user.support.toastCreateOk': "Ticket creado",
    'user.support.toastCreateFail': "No se pudo crear el ticket",
    'user.support.toastReplyOk': "Respuesta enviada",
    'user.support.toastReplyFail': "No se pudo enviar la respuesta",
    'user.support.toastCloseOk': "Ticket cerrado",
    'user.support.toastCloseFail': "No se pudo cerrar el ticket",
    'agent.layout.nav.support': "Поддержка",
    'agent.page.support': "Поддержка",
    'agent.support.myTickets': "Мои тикеты",
    'agent.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'agent.support.newTicket': "Новый тикет",
    'agent.support.empty': "Aún no tienes tickets de soporte.",
    'agent.support.loading': "Cargando…",
    'agent.support.backToList': "Volver a tickets",
    'agent.support.category': "Categoría",
    'agent.support.subject': "Asunto",
    'agent.support.subjectPlaceholder': "Breve resumen del problema",
    'agent.support.message': "Mensaje",
    'agent.support.messagePlaceholder': "Describe tu problema…",
    'agent.support.attachments': "Imágenes",
    'agent.support.addImages': "Añadir imágenes",
    'agent.support.removeImage': "Удалить изображение",
    'agent.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'agent.support.submit': "Enviar ticket",
    'agent.support.submitting': "Enviando…",
    'agent.support.reply': "Tu respuesta",
    'agent.support.replyPlaceholder': "Escribe una respuesta…",
    'agent.support.sendReply': "Enviar respuesta",
    'agent.support.closeTicket': "Cerrar ticket",
    'agent.support.closing': "Cerrando…",
    'agent.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'agent.support.roleAdmin': "Поддержка",
    'agent.support.roleYou': "Tú",
    'agent.support.status.PENDING': "Ожидает",
    'agent.support.status.PROCESSING': "В работе",
    'agent.support.status.CLOSED': "Закрыт",
    'agent.support.category.Account': "Cuenta",
    'agent.support.category.Deposit': "Depósito",
    'agent.support.category.Withdrawal': "Retiro",
    'agent.support.category.Investment': "Inversión",
    'agent.support.category.Technical': "Técnico",
    'agent.support.category.Other': "Otro",
    'agent.support.toastLoadFail': "No se pudieron cargar los tickets",
    'agent.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'agent.support.toastCreateOk': "Ticket creado",
    'agent.support.toastCreateFail': "No se pudo crear el ticket",
    'agent.support.toastReplyOk': "Respuesta enviada",
    'agent.support.toastReplyFail': "No se pudo enviar la respuesta",
    'agent.support.toastCloseOk': "Ticket cerrado",
    'agent.support.toastCloseFail': "No se pudo cerrar el ticket",
  },
  bn: {
    'user.layout.nav.support': "সাপোর্ট",
    'user.page.support': "সাপোর্ট",
    'user.support.myTickets': "আমার টিকিট",
    'user.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'user.support.newTicket': "নতুন টিকিট",
    'user.support.empty': "Aún no tienes tickets de soporte.",
    'user.support.loading': "Cargando…",
    'user.support.backToList': "Volver a tickets",
    'user.support.category': "Categoría",
    'user.support.subject': "Asunto",
    'user.support.subjectPlaceholder': "Breve resumen del problema",
    'user.support.message': "Mensaje",
    'user.support.messagePlaceholder': "Describe tu problema…",
    'user.support.attachments': "Imágenes",
    'user.support.addImages': "Añadir imágenes",
    'user.support.removeImage': "ছবি সরান",
    'user.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'user.support.submit': "Enviar ticket",
    'user.support.submitting': "Enviando…",
    'user.support.reply': "Tu respuesta",
    'user.support.replyPlaceholder': "Escribe una respuesta…",
    'user.support.sendReply': "Enviar respuesta",
    'user.support.closeTicket': "Cerrar ticket",
    'user.support.closing': "Cerrando…",
    'user.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'user.support.roleAdmin': "সাপোর্ট",
    'user.support.roleYou': "Tú",
    'user.support.status.PENDING': "মুলতুবি",
    'user.support.status.PROCESSING': "প্রক্রিয়াধীন",
    'user.support.status.CLOSED': "বন্ধ",
    'user.support.category.Account': "Cuenta",
    'user.support.category.Deposit': "Depósito",
    'user.support.category.Withdrawal': "Retiro",
    'user.support.category.Investment': "Inversión",
    'user.support.category.Technical': "Técnico",
    'user.support.category.Other': "Otro",
    'user.support.toastLoadFail': "No se pudieron cargar los tickets",
    'user.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'user.support.toastCreateOk': "Ticket creado",
    'user.support.toastCreateFail': "No se pudo crear el ticket",
    'user.support.toastReplyOk': "Respuesta enviada",
    'user.support.toastReplyFail': "No se pudo enviar la respuesta",
    'user.support.toastCloseOk': "Ticket cerrado",
    'user.support.toastCloseFail': "No se pudo cerrar el ticket",
    'agent.layout.nav.support': "সাপোর্ট",
    'agent.page.support': "সাপোর্ট",
    'agent.support.myTickets': "আমার টিকিট",
    'agent.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'agent.support.newTicket': "নতুন টিকিট",
    'agent.support.empty': "Aún no tienes tickets de soporte.",
    'agent.support.loading': "Cargando…",
    'agent.support.backToList': "Volver a tickets",
    'agent.support.category': "Categoría",
    'agent.support.subject': "Asunto",
    'agent.support.subjectPlaceholder': "Breve resumen del problema",
    'agent.support.message': "Mensaje",
    'agent.support.messagePlaceholder': "Describe tu problema…",
    'agent.support.attachments': "Imágenes",
    'agent.support.addImages': "Añadir imágenes",
    'agent.support.removeImage': "ছবি সরান",
    'agent.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'agent.support.submit': "Enviar ticket",
    'agent.support.submitting': "Enviando…",
    'agent.support.reply': "Tu respuesta",
    'agent.support.replyPlaceholder': "Escribe una respuesta…",
    'agent.support.sendReply': "Enviar respuesta",
    'agent.support.closeTicket': "Cerrar ticket",
    'agent.support.closing': "Cerrando…",
    'agent.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'agent.support.roleAdmin': "সাপোর্ট",
    'agent.support.roleYou': "Tú",
    'agent.support.status.PENDING': "মুলতুবি",
    'agent.support.status.PROCESSING': "প্রক্রিয়াধীন",
    'agent.support.status.CLOSED': "বন্ধ",
    'agent.support.category.Account': "Cuenta",
    'agent.support.category.Deposit': "Depósito",
    'agent.support.category.Withdrawal': "Retiro",
    'agent.support.category.Investment': "Inversión",
    'agent.support.category.Technical': "Técnico",
    'agent.support.category.Other': "Otro",
    'agent.support.toastLoadFail': "No se pudieron cargar los tickets",
    'agent.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'agent.support.toastCreateOk': "Ticket creado",
    'agent.support.toastCreateFail': "No se pudo crear el ticket",
    'agent.support.toastReplyOk': "Respuesta enviada",
    'agent.support.toastReplyFail': "No se pudo enviar la respuesta",
    'agent.support.toastCloseOk': "Ticket cerrado",
    'agent.support.toastCloseFail': "No se pudo cerrar el ticket",
  },
  hi: {
    'user.layout.nav.support': "सहायता",
    'user.page.support': "सहायता",
    'user.support.myTickets': "मेरे टिकट",
    'user.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'user.support.newTicket': "नया टिकट",
    'user.support.empty': "Aún no tienes tickets de soporte.",
    'user.support.loading': "Cargando…",
    'user.support.backToList': "Volver a tickets",
    'user.support.category': "Categoría",
    'user.support.subject': "Asunto",
    'user.support.subjectPlaceholder': "Breve resumen del problema",
    'user.support.message': "Mensaje",
    'user.support.messagePlaceholder': "Describe tu problema…",
    'user.support.attachments': "Imágenes",
    'user.support.addImages': "Añadir imágenes",
    'user.support.removeImage': "छवि हटाएँ",
    'user.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'user.support.submit': "Enviar ticket",
    'user.support.submitting': "Enviando…",
    'user.support.reply': "Tu respuesta",
    'user.support.replyPlaceholder': "Escribe una respuesta…",
    'user.support.sendReply': "Enviar respuesta",
    'user.support.closeTicket': "Cerrar ticket",
    'user.support.closing': "Cerrando…",
    'user.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'user.support.roleAdmin': "सहायता",
    'user.support.roleYou': "Tú",
    'user.support.status.PENDING': "लंबित",
    'user.support.status.PROCESSING': "प्रक्रिया में",
    'user.support.status.CLOSED': "बंद",
    'user.support.category.Account': "Cuenta",
    'user.support.category.Deposit': "Depósito",
    'user.support.category.Withdrawal': "Retiro",
    'user.support.category.Investment': "Inversión",
    'user.support.category.Technical': "Técnico",
    'user.support.category.Other': "Otro",
    'user.support.toastLoadFail': "No se pudieron cargar los tickets",
    'user.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'user.support.toastCreateOk': "Ticket creado",
    'user.support.toastCreateFail': "No se pudo crear el ticket",
    'user.support.toastReplyOk': "Respuesta enviada",
    'user.support.toastReplyFail': "No se pudo enviar la respuesta",
    'user.support.toastCloseOk': "Ticket cerrado",
    'user.support.toastCloseFail': "No se pudo cerrar el ticket",
    'agent.layout.nav.support': "सहायता",
    'agent.page.support': "सहायता",
    'agent.support.myTickets': "मेरे टिकट",
    'agent.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'agent.support.newTicket': "नया टिकट",
    'agent.support.empty': "Aún no tienes tickets de soporte.",
    'agent.support.loading': "Cargando…",
    'agent.support.backToList': "Volver a tickets",
    'agent.support.category': "Categoría",
    'agent.support.subject': "Asunto",
    'agent.support.subjectPlaceholder': "Breve resumen del problema",
    'agent.support.message': "Mensaje",
    'agent.support.messagePlaceholder': "Describe tu problema…",
    'agent.support.attachments': "Imágenes",
    'agent.support.addImages': "Añadir imágenes",
    'agent.support.removeImage': "छवि हटाएँ",
    'agent.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'agent.support.submit': "Enviar ticket",
    'agent.support.submitting': "Enviando…",
    'agent.support.reply': "Tu respuesta",
    'agent.support.replyPlaceholder': "Escribe una respuesta…",
    'agent.support.sendReply': "Enviar respuesta",
    'agent.support.closeTicket': "Cerrar ticket",
    'agent.support.closing': "Cerrando…",
    'agent.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'agent.support.roleAdmin': "सहायता",
    'agent.support.roleYou': "Tú",
    'agent.support.status.PENDING': "लंबित",
    'agent.support.status.PROCESSING': "प्रक्रिया में",
    'agent.support.status.CLOSED': "बंद",
    'agent.support.category.Account': "Cuenta",
    'agent.support.category.Deposit': "Depósito",
    'agent.support.category.Withdrawal': "Retiro",
    'agent.support.category.Investment': "Inversión",
    'agent.support.category.Technical': "Técnico",
    'agent.support.category.Other': "Otro",
    'agent.support.toastLoadFail': "No se pudieron cargar los tickets",
    'agent.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'agent.support.toastCreateOk': "Ticket creado",
    'agent.support.toastCreateFail': "No se pudo crear el ticket",
    'agent.support.toastReplyOk': "Respuesta enviada",
    'agent.support.toastReplyFail': "No se pudo enviar la respuesta",
    'agent.support.toastCloseOk': "Ticket cerrado",
    'agent.support.toastCloseFail': "No se pudo cerrar el ticket",
  },
  'zh-CN': {
    'user.layout.nav.support': "支持",
    'user.page.support': "支持",
    'user.support.myTickets': "我的工单",
    'user.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'user.support.newTicket': "新建工单",
    'user.support.empty': "Aún no tienes tickets de soporte.",
    'user.support.loading': "Cargando…",
    'user.support.backToList': "Volver a tickets",
    'user.support.category': "Categoría",
    'user.support.subject': "Asunto",
    'user.support.subjectPlaceholder': "Breve resumen del problema",
    'user.support.message': "Mensaje",
    'user.support.messagePlaceholder': "Describe tu problema…",
    'user.support.attachments': "Imágenes",
    'user.support.addImages': "Añadir imágenes",
    'user.support.removeImage': "移除图片",
    'user.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'user.support.submit': "Enviar ticket",
    'user.support.submitting': "Enviando…",
    'user.support.reply': "Tu respuesta",
    'user.support.replyPlaceholder': "Escribe una respuesta…",
    'user.support.sendReply': "Enviar respuesta",
    'user.support.closeTicket': "Cerrar ticket",
    'user.support.closing': "Cerrando…",
    'user.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'user.support.roleAdmin': "支持",
    'user.support.roleYou': "Tú",
    'user.support.status.PENDING': "待处理",
    'user.support.status.PROCESSING': "处理中",
    'user.support.status.CLOSED': "已关闭",
    'user.support.category.Account': "Cuenta",
    'user.support.category.Deposit': "Depósito",
    'user.support.category.Withdrawal': "Retiro",
    'user.support.category.Investment': "Inversión",
    'user.support.category.Technical': "Técnico",
    'user.support.category.Other': "Otro",
    'user.support.toastLoadFail': "No se pudieron cargar los tickets",
    'user.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'user.support.toastCreateOk': "Ticket creado",
    'user.support.toastCreateFail': "No se pudo crear el ticket",
    'user.support.toastReplyOk': "Respuesta enviada",
    'user.support.toastReplyFail': "No se pudo enviar la respuesta",
    'user.support.toastCloseOk': "Ticket cerrado",
    'user.support.toastCloseFail': "No se pudo cerrar el ticket",
    'agent.layout.nav.support': "支持",
    'agent.page.support': "支持",
    'agent.support.myTickets': "我的工单",
    'agent.support.listHint': "Crea un ticket y chatea con nuestro equipo de soporte.",
    'agent.support.newTicket': "新建工单",
    'agent.support.empty': "Aún no tienes tickets de soporte.",
    'agent.support.loading': "Cargando…",
    'agent.support.backToList': "Volver a tickets",
    'agent.support.category': "Categoría",
    'agent.support.subject': "Asunto",
    'agent.support.subjectPlaceholder': "Breve resumen del problema",
    'agent.support.message': "Mensaje",
    'agent.support.messagePlaceholder': "Describe tu problema…",
    'agent.support.attachments': "Imágenes",
    'agent.support.addImages': "Añadir imágenes",
    'agent.support.removeImage': "移除图片",
    'agent.support.attachmentsHint': "JPG, PNG, WEBP o GIF · máx. 3 archivos · 5 MB cada uno",
    'agent.support.submit': "Enviar ticket",
    'agent.support.submitting': "Enviando…",
    'agent.support.reply': "Tu respuesta",
    'agent.support.replyPlaceholder': "Escribe una respuesta…",
    'agent.support.sendReply': "Enviar respuesta",
    'agent.support.closeTicket': "Cerrar ticket",
    'agent.support.closing': "Cerrando…",
    'agent.support.closedHint': "Este ticket está cerrado. Crea uno nuevo si aún necesitas ayuda.",
    'agent.support.roleAdmin': "支持",
    'agent.support.roleYou': "Tú",
    'agent.support.status.PENDING': "待处理",
    'agent.support.status.PROCESSING': "处理中",
    'agent.support.status.CLOSED': "已关闭",
    'agent.support.category.Account': "Cuenta",
    'agent.support.category.Deposit': "Depósito",
    'agent.support.category.Withdrawal': "Retiro",
    'agent.support.category.Investment': "Inversión",
    'agent.support.category.Technical': "Técnico",
    'agent.support.category.Other': "Otro",
    'agent.support.toastLoadFail': "No se pudieron cargar los tickets",
    'agent.support.toastNeedMessage': "Escribe un mensaje o adjunta una imagen",
    'agent.support.toastCreateOk': "Ticket creado",
    'agent.support.toastCreateFail': "No se pudo crear el ticket",
    'agent.support.toastReplyOk': "Respuesta enviada",
    'agent.support.toastReplyFail': "No se pudo enviar la respuesta",
    'agent.support.toastCloseOk': "Ticket cerrado",
    'agent.support.toastCloseFail': "No se pudo cerrar el ticket",
  },
};
